<template>
  <div class="ecm__login">
    <div class="ecm__login-welcome">
      <h1 @click="$router.push('/')">Welcome to BukuBook</h1>
      <p>
        If you don't have an account, please register first to stay connected with us
      </p>
      <button @click="$router.push('/register')">
        Register
      </button>
    </div>
    <div class="ecm__login-form">
      <div class="ecm__login-form__content">
        <h1 class="ecm__login-form__content--logo logo--title">BukuBook</h1>
        <el-form
          class="ecm__login-form__content-form"
          :model="loginForm"
          :rules="rules"
          ref="ruleForm"
          @submit.prevent.native="handleForm('ruleForm')"
        >
          <Input
            :field="'email'"
            :placeholder="'Your Email'"
            v-model="loginForm.email"
          />
          <Input
            :field="'password'"
            :placeholder="'Your Password'"
            :inputType="'password'"
            v-model="loginForm.password"
          />
          <div v-if="errorMessage" :class="[errorMessage ? 'ecm__login-form__content-error active' : 'ecm__login-form__content-error']">
            <p>{{ errorMessage }}</p>
          </div>
          <button class="ecm__login-form__content-form__btn-submit" native-type="submit">Submit</button>
        </el-form>
        <!-- <GoogleLogin class="ecm-login-btn--google" :params="params" :onSuccess="onSuccess">
            <i class="fab fa-google-plus-g"></i>
        </GoogleLogin> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Input from '@/components/inputs/Input.vue'
import { instance as Axios, setAccessToken } from '@/config/axiosInstance.js'
import GoogleLogin from 'vue-google-login';

export default {
  name: 'Login',
  components: {
    Input,
    GoogleLogin
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      params: {
          client_id: "526852320651-25tkreshg4sn3dv6pthivfpqm8dh83tj.apps.googleusercontent.com"
      },
      prevRoute: null,
      errorMessage: '',
      loginForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please input your email', trigger: 'blur' },
          { type: 'email', message: 'email must be email format', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please input your password', trigger: 'blur' },
          { min: 5, message: 'Minimum character length is 5 characters', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      getWishlistCount: 'wishlist/fetchCount',
      getCartCount: 'cart/fetchCount'
    }),
    async onSuccess(googleUser) {
      try {
        const id_token = googleUser.getAuthResponse().id_token
        const resp = await Axios.post('user/google', {
          token: id_token
        })
        this.handleSuccessLogin(resp)
      } catch (error) {
        console.log(error)
      }
    },
    handleForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Axios({
            method: 'post',
            url: 'user_login',
            data: {
              email: this.$data.loginForm.email,
              password: this.$data.loginForm.password
            }
          })
            .then(res => {
              this.handleSuccessLogin(res)
            })
            .catch(err => {
              this.$data.errorMessage = err.response?.data.msg
              setTimeout(() => {
                this.$data.errorMessage = ''
              }, 5000)
            })
        } else {
          return false
        }
      })
    },
    handleSuccessLogin (res) {
      this.$data.errorMessage = ''
      localStorage.setItem('userId', res.data.id)
      localStorage.setItem('access_token', res.data.access_token)
      setAccessToken(res.data.access_token)
      if (this.$data.prevRoute) {
        this.$router.push(this.$data.prevRoute.path)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__login {
  display: flex;
  background: linear-gradient(315deg, rgba(12,7,82,0.804359243697479) 0%, rgba(66,125,240,0.14889705882352944) 100%),
            url("https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1034&q=80");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .ecm__login-welcome,
  .ecm__login-form {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    flex-direction: column;
  }
  .ecm__login-welcome {
    flex: 0.8;
    color: white;
    text-align: center;
    h1 {
      font-weight: 500;
      font-size: 45px;
      transition: .3s;
      cursor: pointer;
    }
    p {
      font-weight: 300;
      width: 680px;
      font-size: 25px;
    }
    button {
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
      margin-top: 30px;
      width: 175px;
      height: 45px;
      border-radius: 30px;
      font-weight: 500;
      letter-spacing: 1px;
      font-size: 20px;
      color: white;
      border: 1px solid white;
      transition: .3s;
      &:hover {
        background: white;
        color: rgb(24, 56, 119);
      }
    }
  }
  .ecm__login-form {
    right: 5%;
    color: var(--color-blue);
    position: absolute;
    .ecm__login-form__content {
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      background: white;
      border-radius: 3px;
      padding: 35px 30px 60px;
      width: 370px;
      .ecm__login-form__content--logo {
        font-size: 25px;
        margin-bottom: 10px;
        text-align: center;
      }
      button {
        width: 100%;
        height: 35px;
        font-size: 14px;
        border: none;
        outline: none;
        cursor: pointer;
        border-radius: 5px;
        transition: .2s;
        color: white;
        font-weight: 500;
      }
      .ecm__login-form__content-error {
        background: white;
        height: 30px;
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px;
        color: white;
        width: 100%;
        &.active {
          background: rgb(255, 117, 117);
        }
      }
      .ecm__login-form__content-form__btn-submit {
        margin-top: 8px;
        background: var(--color-blue-background);
        &:hover {
          background: var(--color-blue);
        }
      }
    }
    .ecm-login-btn--google {
      margin-top: 10px;
      background: rgb(255, 47, 0);
      &:hover {
        background: rgb(255, 17, 0);
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__login {
    min-height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ecm__login-welcome,
    .ecm__login-form {
      min-height: auto;
    }
    .ecm__login-welcome {
      margin-top: -200px;
      margin-bottom: 70px;
      flex: 0;
      h1 {
        font-size: 70px;
      }
      p {
        font-weight: 400;
        width: 700px;
        font-size: 35px;
      }
      button {
        width: 250px;
        height: 63px;
        font-size: 30px;
        font-weight: 500;
      }
    }
    .ecm__login-form {
      position: static;
      .ecm__login-form__content {
        width: 500px;
        h1 {
          font-weight: 600;
          font-size: 50px;
          margin-bottom: 10px;
        }
        button {
          padding: 10px 0;
          font-size: 25px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__login {
    .ecm__login-welcome,
    .ecm__login-form {
      min-height: auto;
    }
    .ecm__login-welcome {
      margin-top: -70px;
      margin-bottom: 50px;
      flex: 0;
      h1 {
        font-size: 50px;
      }
      p {
        // font-weight: 400;
        width: 550px;
        font-size: 23px;
      }
      button {
        margin-top: 20px;
        width: 230px;
        height: 53px;
        font-size: 23px;
      }
    }
    .ecm__login-form {
      .ecm__login-form__content {
        width: 500px;
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__login {
    min-height: 100vh;
    .ecm__login-welcome {
      margin-top: -60px;
      margin-bottom: 40px;
      flex: 0;
      h1 {
        font-size: 28px;
        width: 270px;
      }
      p {
        width: 350px;
        font-size: 16px;
      }
      button {
        margin-top: 15px;
        width: 140px;
        height: 33px;
        font-size: 15px;
        font-weight: 500;
      }
    }
    .ecm__login-form {
      .ecm__login-form__content {
        width: 280px;
        h1 {
          font-weight: 500;
          font-size: 25px;
          margin-bottom: 10px;
        }
        button {
          padding: 4px 0;
          font-size: 15px;
        }
        .ecm__login-form__content-error {
          font-size: 14px;
          height: 22px;
        }
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .ecm__login {
    .ecm__login-welcome {
      margin-top: -20px;
      margin-bottom: 20px;
      h1 {
        font-size: 20px;
        width: 190px;
      }
      p {
        font-weight: 400;
        width: 280px;
        font-size: 13px;
      }
      button {
        margin-top: 10px;
        width: 100px;
        height: 25px;
        font-size: 11px;
        font-weight: 500;
      }
    }
    .ecm__login-form {
      .ecm__login-form__content {
        width: 250px;
        h1 {
          font-weight: 500;
          font-size: 18px;
          margin-bottom: 5px;
        }
        button {
          padding: 3px 0;
          font-size: 13px;
        }
        .ecm__login-form__content-form__btn-submit {
          margin-top: 10px;
        }
        .ecm__login-form__content-form__btn-google {
          margin-top: 5px;
        }
        .ecm__login-form__content-error {
          font-size: 12px;
          height: 20px;
          margin-top: -15px;
        }
      }
    }
  }
}

</style>
